import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { CardMedia, Grid, Typography } from "@mui/material";

export default function DialogWait(props) {
  const { open, isModel, title, massage, btn, errorCode } = props;
  const handleClose = (type) => {
    isModel(!open);
  };
  return (
    <Dialog open={open}>
      <DialogTitle
        style={{
          paddingTop: "43px",
        }}
      >
        <Grid>
          <Grid>
            <CardMedia
              component="img"
              className="img-dialog"
              image={"../../../images/warning.svg"}
              sx={{ width: 100 }}
              alt="warning"
            />
            <Typography className="font-title text-center font-24 font-weight-bold">
              {title}
            </Typography>
            {errorCode && <DialogContentText className="font-16 text-center">ErrorCode ({errorCode})</DialogContentText>}
          </Grid>

        </Grid>
      </DialogTitle>

      <DialogContent>

        <DialogContentText
          id="alert-dialog-description"
          className="font-title text-center font-22"
          dangerouslySetInnerHTML={{
            __html: massage,
          }}
        />
      </DialogContent>
      <DialogActions
        style={{
          paddingTop: "25px",
        }}
      >
        <Button onClick={() => handleClose("")} className="btn-next font-20">
          {btn}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
